import { jsx as _jsx } from "react/jsx-runtime";
import { TriangleDown } from "@air/next-icons";
import { tailwindMerge } from "@air/tailwind-variants";
import * as RadixSelect from "@radix-ui/react-select";
import { forwardRef } from "react";
export const SelectIcon = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { children, className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(RadixSelect.SelectIcon, {
        asChild: true,
        className: tailwindMerge("size-4 shrink-0 text-grey-9", className),
        ...restOfProps,
        ref: forwardedRef,
        children: children ? children : /*#__PURE__*/ _jsx(TriangleDown, {})
    });
});
SelectIcon.displayName = "SelectIcon";
